import React, { useContext, useState } from 'react';
import { GlobalDataContext } from '../../../context/context';
import { NavLink } from 'react-router-dom';
import { GiHamburgerMenu } from 'react-icons/gi'
import { MdClose } from 'react-icons/md'
import { GoChevronDown, GoChevronUp } from 'react-icons/go'


const Navmenu = () => {
    const { rpdata } = useContext(GlobalDataContext);

    const [openMenu, setOpenMenu] = useState(false)
    const [openSubMenu, setOpenSubMenu] = useState(false)
    const [openSubMenu2, setOpenSubMenu2] = useState(false)
    const [openSubMenu3, setOpenSubMenu3] = useState(false)
    // const [openSubMenu4, setOpenSubMenu4] = useState(false)
    // const [openSubMenu5, setOpenSubMenu5] = useState(false)
    const [openSubMenuGallery, setOpenSubMenuGallery] = useState(false)

    const handleClickSubMenu = () => {
        setOpenSubMenu(!openSubMenu);
        setOpenSubMenu2(false);
        setOpenSubMenu3(false);
        // setOpenSubMenu5(false);
    }

    const handleClickSubMenu2 = () => {
        setOpenSubMenu(false);
        setOpenSubMenu2(!openSubMenu2);
        setOpenSubMenu3(false);
        // setOpenSubMenu5(false);
    }

    const handleClickSubMenu3 = () => {
        setOpenSubMenu(false);
        setOpenSubMenu2(false);
        setOpenSubMenu3(!openSubMenu3);
        // setOpenSubMenu5(false);
    }

    // const handleClickSubMenu4 = () => {
    //     setOpenSubMenu(false);
    //     setOpenSubMenu2(!openSubMenu4);
    //     setOpenSubMenu4(false);
    // }

    // const handleClickSubMenu5 = () => {
    //     setOpenSubMenu(false);
    //     setOpenSubMenu2(false);
    //     setOpenSubMenu5(!openSubMenu5);
    //     setOpenSubMenu3(false);
    // }

    const handleClickSubMenuGallery = () => {
        return setOpenSubMenuGallery(!openSubMenuGallery)
    }

    const handleClick = () => {
        return setOpenMenu(!openMenu)
    }

    //sub menu
    const subitems = rpdata?.dbServices?.slice(0, 13)?.map((itemsMenu, index) => {
        return (
            {
                subname: itemsMenu.name,
                sublink: `/${itemsMenu.name.replaceAll(/[\^*@!"#$%&/()=?¡!¿' ]/g, "-").toLowerCase()}`,
            }
        )
    })

    const subitems2 = rpdata?.dbServices?.slice(13, 15)?.map((itemsMenu, index) => {
        return (
            {
                subname: itemsMenu.name,
                sublink: `/${itemsMenu.name.replaceAll(/[\^*@!"#$%&/()=?¡!¿' ]/g, "-").toLowerCase()}`,
            }
        )
    })

    const subitems3 = rpdata?.dbServices?.slice(15, 20)?.map((itemsMenu, index) => {
        return (
            {
                subname: itemsMenu.name,
                sublink: `/${itemsMenu.name.replaceAll(/[\^*@!"#$%&/()=?¡!¿' ]/g, "-").toLowerCase()}`,
            }
        )
    })

    // const subitems4 = rpdata?.dbServices?.slice(2, 3)?.map((itemsMenu, index) => {
    //     return (
    //         {
    //             subname: itemsMenu.name,
    //             sublink: `/${itemsMenu.name.replaceAll(/[\^*@!"#$%&/()=?¡!¿' ]/g, "-").toLowerCase()}`,
    //         }
    //     )
    // })

    // const subitems5 = rpdata?.dbServices?.slice(3, 12)?.map((itemsMenu, index) => {
    //     return (
    //         {
    //             subname: itemsMenu.name,
    //             sublink: `/${itemsMenu.name.replaceAll(/[\^*@!"#$%&/()=?¡!¿' ]/g, "-").toLowerCase()}`,
    //         }
    //     )
    // })

    //sub menu
    const subitemsGallery = rpdata?.landings?.map((itemsGallery, index) => {
        return (
            {
                subname: itemsGallery.name,
                sublink: `/gallery/${itemsGallery.name.replaceAll(/[\^*@!"#$%&/()=?¡!¿' ]/g, "-").toLowerCase()}`,
            }
        )
    })
    // menu

    const dbMenu = [
        {
            name: `Home`,
            link: `/`,
            child: false,

        },
        {
            name: `About`,
            link: `/about`,
            child: false,
        },
        {
            name: `Roofing Residential and Commercial`,
            link: `/`,
            child: rpdata?.autoGntLandingFromService,
            submenu: [...(subitems ? subitems : [])],
            click: handleClickSubMenu,
            opens: openSubMenu,
        },
        {
            name: `Painting `,
            link: `/`,
            child: rpdata?.autoGntLandingFromService,
            submenu: [...(subitems2 ? subitems2 : [])],
            click: handleClickSubMenu2,
            opens: openSubMenu2,
        },
        {
            name: `Remodeling and Renovation `,
            link: `/`,
            child: rpdata?.autoGntLandingFromService,
            submenu: [...(subitems3 ? subitems3 : [])],
            click: handleClickSubMenu3,
            opens: openSubMenu3,
        },
        // {
        //     name: `Bathroom Installment & Repair`,
        //     link: `/`,
        //     child: rpdata?.autoGntLandingFromService,
        //     submenu: [...(subitems4 ? subitems4 : [])],
        //     click: handleClickSubMenu4,
        //     opens: openSubMenu4,
        // },
        // {
        //     name: `Complete Remodels & Additions Painting`,
        //     link: `/`,
        //     child: rpdata?.autoGntLandingFromService,
        //     submenu: [...(subitems5 ? subitems5 : [])],
        //     click: handleClickSubMenu5,
        //     opens: openSubMenu5,
        // },
        {
            name: `Gallery`,
            link: `/gallery`,
            child: rpdata?.customLinks,
            submenu: [...(subitemsGallery ? subitemsGallery : [])],
            click: handleClickSubMenuGallery,
            opens: openSubMenuGallery,
        },
        {
            name: `Contact`,
            link: `/contact`,
            child: false,
        },
    ]


    // agregar la pestaña de Video al array de dbMenu

    const yt = {
        name: `Our Videos`,
        link: `/our-videos`,
        child: false,
    }

    if (rpdata?.ytGallery?.linkCanalYT) {
        const num = dbMenu.length - 1
        dbMenu.splice(num, 0, yt)
    }
    //  fin de agregar pestaña de Video

    // agregar la pestaña de reviews al array de dbMenu

    const el = {
        name: `Reviews`,
        link: `/reviews`,
        child: false,
    }

    if (rpdata?.reviews?.activo && rpdata?.reviews?.isHomeOnly === false) {
        const num = dbMenu.length - 1
        dbMenu.splice(num, 0, el)
    }
    //  fin de agregar pestaña de reviews



    return (
        <div className='w-full'>
            <ul className='hidden md:flex menuContent'>
                {
                    dbMenu.map((items, index) => {
                        return (
                            items.child ?
                                <li key={index} className='menuContent__items text-[19px]'>
                                    <div className='flex items-center'>
                                        {items.name}
                                        <GoChevronDown className='ml-1' />
                                    </div>
                                    <ul
                                        className={
                                            items.child && items.name === 'Gallery' ?
                                                `menuContent__subMenu h-[200px]`
                                                : `menuContent__subMenu h-[220px]`
                                        }
                                    >
                                        {
                                            items.submenu.map((itemSub, index) => {
                                                return (
                                                    <NavLink key={index} to={itemSub.sublink}>
                                                        <li className='text-[17px]'>
                                                            {itemSub.subname}
                                                        </li>
                                                    </NavLink>
                                                )
                                            })
                                        }
                                    </ul>
                                </li>
                                :
                                <NavLink to={items.link} >
                                    <li className='menuContent__items text-[19px]'>
                                        {items.name}
                                    </li>
                                </NavLink>
                        )
                    })
                }
            </ul>
            <div className='flex justify-center md:hidden bgBtnMenu rounded-lg p-2 mx-1 cursor-pointer' onClick={handleClick}>
                {
                    openMenu ?
                        <MdClose fontSize={30} color={'white'} />
                        : <GiHamburgerMenu fontSize={30} color={'white'} />
                }
            </div>
            <div className={`
                ${openMenu ? 'w-full block absolute z-50 transition duration-500 ease-in-out' : 'hidden'}
            `}>
                <ul className='mobilMenuHeader'>
                    {
                        dbMenu.map((items, index) => {
                            return (
                                items.child ?
                                    <li key={index}
                                        className='menuContent__subItems'
                                        onClick={items.click}
                                    >
                                        <div className='flex items-center'>
                                            {items.name}
                                            {
                                                items.opens ?
                                                    <GoChevronUp className='ml-1' />
                                                    : <GoChevronDown className='ml-1' />
                                            }
                                        </div>
                                        <ul className={items.opens ? 'block mt-3 menuContent__subMenuMobil' : 'hidden'}>
                                            {
                                                items.submenu.map((itemSub, index) => {
                                                    return (
                                                        <NavLink key={index} to={itemSub.sublink}>
                                                            <li className='p-2'>
                                                                {itemSub.subname}
                                                            </li>
                                                        </NavLink>
                                                    )
                                                })
                                            }
                                        </ul>
                                    </li>
                                    :
                                    <NavLink to={items.link} >
                                        <li className='menuContent__subItems'>
                                            {items.name}
                                        </li>
                                    </NavLink>
                            )
                        })
                    }
                </ul>
            </div>
        </div>
    );
}


export default Navmenu;